export const THEME_STORAGE_KEY = 'theme'
